import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/Table';
import { transactionDetails as TEXT } from 'locales/en/transaction';

const ChargebackFees = ({ data }) => {
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
        {TEXT.chargeback.title}
      </h2>
      <Table gridClassName="grid-cols-3" hasData={!!data.length}>
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;

          return (
            <Fragment key={item.id}>
              <span
                data-index-number={dataIndexNumber}
                className="underline text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 font-bold"
              >
                {item.amountToDisplay}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.event}
              </span>
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

ChargebackFees.propTypes = {
  data: PropTypes.array,
};
ChargebackFees.defaultProps = {
  data: [],
};
export default ChargebackFees;
